import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/solid";
import WorksiteNameColumn from "@components/WorksiteNameColumn";
import Badge from "@ui-components/Badge";
import {UsersInvolved, Option} from "./types";
import {ModalOpenerButton} from "../../Resales/ModalOpenerButton";
import {UsersKpiTableFilter} from "./UserKpiTableFilter";


export const getColumns = (
  intl: any,
  countryCode: string,
  userMap: {[key: number]: string},
  userOptions: Option[],
  servicesMap: {[key: number]: string},
  setShowInvolvedUsersModal: (value: boolean | UsersInvolved) => void,
) => {

  return [{
    title: "Link",
    field: "id",
    filtering: false,
    sorting: false,
    render: ({id}) => (
      <div>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={`/${countryCode}/worksites/${id}`}
        >
          <ArrowTopRightOnSquareIcon
            className={`w-6 h-6 mt-2 text-kerakoll-400 cursor-pointer`}
          />
        </a>
      </div>
    ),
  },
    {
      title: intl.formatMessage({id: "name"}),
      field: "address",
      type: "string",
      headerStyle: {minWidth: 250},
      cellStyle: {minWidth: 250, textTransform: "uppercase"},
      sorting: false,
      render: ({address, des_worksite, city}) => (
        <div className="font-semibold">
          <WorksiteNameColumn
            des_worksite={des_worksite}
            address={address}
            city={city}
          />
        </div>
      ),
    },
    {
      title: intl.formatMessage({id: "created_at", defaultMessage: "data di creazione"}),
      field: "created_at",
      type: "date",
      render: ({created_at}) => {
        return new Date(created_at).toLocaleDateString("it-IT", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        });
      },
      filtering: false,
    },
    {
      title: intl.formatMessage({id: "specified_by", defaultMessage: "specificato da"}),
      field: "specifiers",
      minWidth: 300,
      filterComponent: (props) => <UsersKpiTableFilter
        {...props}
        userOptions={userOptions.filter(u=>u.label.endsWith('Field)'))}
      />,
      sorting: false,
      render: ({specifiers}) => {
        return specifiers.map((s) => userMap[s] || '').join(", ");
      }
    },
    {
      title: intl.formatMessage({id: "involved_users", defaultMessage: "utenti coinvolti"}),
      sorting: false,
      filtering: true,
      minWidth: 300,
      field: "users_involved",
      filterComponent: (props) => <UsersKpiTableFilter {...props} userOptions={userOptions} />,
      // created is a single user, shared is a list of users as well as visible
      render: ({users_involved}: UsersInvolved) => {
        const {created, shared, visible} = users_involved;
        return <>
          <ModalOpenerButton
            value={[
              ...(created ? [created] : []),
              ...(shared? shared : []),
              ...(visible? visible : []),
            ]}
            stateSetterFn={() => {
              const newValue: UsersInvolved = {
                created: created,
                shared: shared,
                visible: visible,
              }
              setShowInvolvedUsersModal(newValue);
            }}
          />
        </>
      }
    },
    {
      title: intl.formatMessage({
        id: "configurations",
        defaultMessage: "Configurazioni",
      }),
      field: "services",
      filtering: false,
      sorting: false,
      render: function (row) {
        return row["services"] ? (
          <div>
            {row["services"].map((s) =>
              s ? (
                <Badge
                  classNames="mb-1 mr-1"
                  text={servicesMap[s]}
                  key={s}
                  textSize="text-xxs"
                />
              ) : null
            )}
          </div>
        ) : null;
      },
    },
    {
      title: " #",
      field: "num_surveys",
      type: "string",
      filtering: false,
      sorting: false,
      render: ({num_surveys}) => (
        <div className="font-semibold text-xl">{num_surveys}</div>
      ),
    },
    {
      title: intl.formatMessage({id: "value", defaultMessage: "Valore"}),
      field: "value",
      type: "string",
      filtering: false,
      render: ({value}) => (
        <div className="font-semibold text-lg">
          {intl.formatNumber(value, {
            style: "currency",
            currency: "EUR",
            maximumFractionDigits: 0,
          })}
        </div>
      ),
    },
  ]
}